
export const LOGO = {
    src: "/logo.svg",
    alt: `${import.meta.env.VITE_PROJECT_NAME} Logo`
}

export const PROJECT_NAME = import.meta.env.VITE_PROJECT_NAME || "Qolca Solutions"

export const SOCIAL_LINKS = {
    instagram: 'https://www.instagram.com/qolca.peru/',
    tiktok: 'https://www.tiktok.com/@qolca.peru',
} as const

export const COMPANY = {
    name: 'Qolca',
    url: 'https://qolca.org',
} as const